var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCoverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.979.396a1.516 1.516 0 0 1 2.043 0l.015.014C14.822 2.13 16.91 3 19.61 3.149c1.295.071 2.325 1.13 2.344 2.41.004.262.01.498.021.721v.018c.053 2.727.118 6.12-1.033 9.204-.63 1.69-1.585 3.16-2.837 4.37-1.425 1.375-3.291 2.467-5.547 3.247a1.735 1.735 0 0 1-.89.062 1.733 1.733 0 0 1-.227-.062c-2.258-.778-4.126-1.87-5.552-3.246-1.253-1.208-2.207-2.677-2.838-4.368-1.146-3.074-1.081-6.461-1.029-9.183l.002-.042c.01-.224.017-.46.02-.72.02-1.281 1.05-2.34 2.344-2.411 2.7-.15 4.79-1.02 6.575-2.739Zm1.02 5.426c-3.227 0-5.852 2.595-5.852 5.785S8.772 17.392 12 17.392c3.227 0 5.853-2.595 5.853-5.785S15.227 5.822 12 5.822Zm0 1.362c2.468 0 4.476 1.984 4.476 4.423S14.467 16.03 12 16.03c-2.468 0-4.475-1.984-4.475-4.423S9.532 7.184 12 7.184Z",
    fill: "#FE9900",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FE9900",
    strokeWidth: 3,
    strokeLinecap: "square",
    d: "M2 29.016h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.303 12.497a1.285 1.285 0 0 1 .022-.54c.045-.162.11-.313.194-.452.083-.14.178-.267.283-.383l.302-.335c.096-.108.175-.212.238-.314a.594.594 0 0 0 .095-.317c0-.18-.056-.317-.167-.41a.658.658 0 0 0-.436-.139.866.866 0 0 0-.446.113 1.97 1.97 0 0 0-.373.288l-.73-.644c.21-.238.461-.43.752-.575.291-.145.613-.218.967-.218.24 0 .464.03.671.087.207.059.387.148.54.27.153.122.273.277.36.466.087.189.13.41.13.666 0 .18-.033.34-.098.483a1.884 1.884 0 0 1-.248.396c-.099.122-.204.24-.315.353-.111.113-.213.23-.306.352a1.62 1.62 0 0 0-.22.388.978.978 0 0 0-.055.465h-1.16Zm.575 2.116a.759.759 0 0 1-.566-.231.785.785 0 0 1-.226-.57c0-.232.075-.425.226-.58a.759.759 0 0 1 .567-.23.787.787 0 0 1 .801.81.777.777 0 0 1-.23.57.774.774 0 0 1-.571.23Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCoverageIcon);
export default ForwardRef;